export const allColors = {
    "#1FBC9C": "verde",
    "#1CA085": "verde",
    "#2ECC70": "pistacho",
    "#27AF60": "verde",
    "#3398DB": "celeste",
    "#2980B9": "azul",
    "#A463BF": "malva",
    "#8E43AD": "uva",
    "#3D556E": "gris",
    "#222F3D": "gris",
    "#F2C511": "ámbar",
    "#F39C19": "miel",
    "#E84B3C": "chocolate",
    "#C0382B": "bermejo",
    "#DDE6E8": "lavanda",
    "#BDC3C8": "plata",
    "#CC0001": "rojo",
    "#E36101": "chocolate",
    "#FFCC00": "dorado",
    "#009900": "verde",
    "#0066CB": "azul",
    "#000000": "negro",
    "#FFFFFF": "blanco",
    "#434343": "gris",
    "#666666": "gris",
    "#999999": "gris",
    "#b7b7b7": "plata",
    "#cccccc": "plata",
    "#d9d9d9": "almendra",
    "#efefef": "gris",
    "#f3f3f3": "marfil",
    "#ffffff": "blanco",
    "#980000": "vinotinto",
    "#ff0000": "rojo",
    "#ff9900": "naranja",
    "#ffff00": "amarillo",
    "#00ff00": "verde",
    "#00ffff": "cian",
    "#4a86e8": "celeste",
    "#0000ff": "azul",
    "#9900ff": "púrpura",
    "#ff00ff": "fucsia",
    "#e6b8af": "melón",
    "#f4cccc": "rosado",
    "#fce5cd": "champán",
    "#fff2cc": "champán",
    "#d9ead3": "almendra",
    "#d0e0e3": "lavanda",
    "#c9daf8": "lavanda",
    "#cfe2f3": "lavanda",
    "#d9d2e9": "lavanda",
    "#ead1dc": "almendra",
    "#dd7e6b": "coral",
    "#ea9999": "rosa",
    "#f9cb9c": "albaricoque",
    "#ffe599": "caqui",
    "#b6d7a8": "plata",
    "#a2c4c9": "plata",
    "#a4c2f4": "celeste",
    "#9fc5e8": "celeste",
    "#b4a7d6": "lila",
    "#d5a6bd": "lila",
    "#cc4125": "bermejo",
    "#e06666": "coral",
    "#f6b26b": "naranja",
    "#ffd966": "mostaza",
    "#93c47d": "pistacho",
    "#76a5af": "verde",
    "#6d9eeb": "celeste",
    "#6fa8dc": "celeste",
    "#8e7cc3": "malva",
    "#c27ba0": "lila",
    "#a61c00": "bermejo",
    "#cc0000": "rojo",
    "#e69138": "naranja",
    "#f1c232": "miel",
    "#6aa84f": "pistacho",
    "#45818e": "verde",
    "#3c78d8": "azul",
    "#3d85c6": "azul",
    "#674ea7": "uva",
    "#a64d79": "uva",
    "#85200c": "cafe",
    "#990000": "cafe",
    "#b45f06": "bermejo",
    "#bf9000": "ocre",
    "#38761d": "verde",
    "#134f5c": "verde",
    "#1155cc": "azul",
    "#0b5394": "azul",
    "#351c75": "morado",
    "#741b47": "vino",
    "#5b0f00": "vinotinto",
    "#660000": "vinotinto",
    "#783f04": "castaño",
    "#7f6000": "amarillo",
    "#274e13": "verde",
    "#0c343d": "verde",
    "#1c4587": "azul",
    "#073763": "azul",
    "#20124d": "azul",
    "#4c1130": "vino"
};
